module.exports = __webpack_public_path__ + "img/jawg-terrain.8a1b40e1.jpg";